// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3C%3Fxml version=%271.0%27 encoding=%27UTF-8%27 standalone=%27no%27%3F%3E%3Csvg focusable=%27false%27 aria-hidden=%27true%27 viewBox=%270 0 24 24%27 data-testid=%27LayersIcon%27 version=%271.1%27 id=%27svg826%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:svg=%27http://www.w3.org/2000/svg%27%3E%3Cdefs id=%27defs830%27 /%3E%3Cpath d=%27m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z%27 id=%27path824%27 style=%27fill:%23666666;fill-opacity:1%27 /%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* controls*/
.ol-control.ol-unselectable {
    padding: 2px;
}

.ol-control button {
    min-width: 24px;
    min-height: 24px;
}

/* Layerswitcher */
.layer-switcher li input {
    margin-top: 4px;
    margin-left: -8px;
}

.layer-switcher .panel>ul {
    max-height: 250px;
}

.entryscape .layer-switcher button {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: initial;
}

.ol-control.layer-switcher {
    top: 0.5em;
}

/*Legend*/
.esbLayerLegend__root {
    bottom: 0.5em;
    left: 0.5em;
    max-width: 40%;
    max-height: 80%;
    display: flex;
    flex-direction: column;
    font-size: 1rem;
}

.esbLayerLegend__root.expanded {
    width: 40%;
}

.esbLayerLegend__expandable {
    display: none;
    width: 100%;
    flex-grow: 1;
    padding: .2em;
    overflow-y: scroll;
    background-color: #ffffff;
}

.expanded .esbLayerLegend__expandable {
    display: block;
}

.esbLayerLegend__root button.esbLayerLegend__button {
    width: auto;
    height: auto;
    line-height: 1.05;
    padding: .2em;
}

.esbLayerLegend__button span {
    margin-right: .7em;
}
p.esbLayerLegend__title {
    margin-top: .5em;
    margin-bottom: .1em;
    word-break: break-word;
    max-width: 96%;
}
img.esbLayerLegend__image {
    width: auto;
    max-width: 96%;
}
div.alert.esbLayerLegend__alert {
    padding: 4px;
    margin: 10px 0;
}

/*Popover*/
.esbMapPopover table {
    table-layout: fixed;
    width: 260px;
}

.esbMapPopover td {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

/*Scale line*/
.olEsbScaleLine.ol-scale-line {
    padding: 3px;
    border-radius: 0;
    position: relative;
    bottom: unset;
    left: unset;
}

/*Attribution*/
.olEsbAttribution.ol-attribution {
    position: relative;
    max-width: 100%;
}

/*Control layer*/
.olEsbControls--absolute {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    max-width: 70%;
}
`, "",{"version":3,"sources":["webpack://./src/graphics/map/openlayers/openLayerMap.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yDAA6f;IAC7f,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA,SAAS;AACT;IACI,aAAa;IACb,WAAW;IACX,cAAc;IACd,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,WAAW;IACX,cAAc;AAClB;AACA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,aAAa;AACb;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,cAAc;AAClB","sourcesContent":["/* controls*/\n.ol-control.ol-unselectable {\n    padding: 2px;\n}\n\n.ol-control button {\n    min-width: 24px;\n    min-height: 24px;\n}\n\n/* Layerswitcher */\n.layer-switcher li input {\n    margin-top: 4px;\n    margin-left: -8px;\n}\n\n.layer-switcher .panel>ul {\n    max-height: 250px;\n}\n\n.entryscape .layer-switcher button {\n    background-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='LayersIcon' version='1.1' id='svg826' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3E%3Cdefs id='defs830' /%3E%3Cpath d='m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z' id='path824' style='fill:%23666666;fill-opacity:1' /%3E%3C/svg%3E%0A\");\n    background-position: initial;\n}\n\n.ol-control.layer-switcher {\n    top: 0.5em;\n}\n\n/*Legend*/\n.esbLayerLegend__root {\n    bottom: 0.5em;\n    left: 0.5em;\n    max-width: 40%;\n    max-height: 80%;\n    display: flex;\n    flex-direction: column;\n    font-size: 1rem;\n}\n\n.esbLayerLegend__root.expanded {\n    width: 40%;\n}\n\n.esbLayerLegend__expandable {\n    display: none;\n    width: 100%;\n    flex-grow: 1;\n    padding: .2em;\n    overflow-y: scroll;\n    background-color: #ffffff;\n}\n\n.expanded .esbLayerLegend__expandable {\n    display: block;\n}\n\n.esbLayerLegend__root button.esbLayerLegend__button {\n    width: auto;\n    height: auto;\n    line-height: 1.05;\n    padding: .2em;\n}\n\n.esbLayerLegend__button span {\n    margin-right: .7em;\n}\np.esbLayerLegend__title {\n    margin-top: .5em;\n    margin-bottom: .1em;\n    word-break: break-word;\n    max-width: 96%;\n}\nimg.esbLayerLegend__image {\n    width: auto;\n    max-width: 96%;\n}\ndiv.alert.esbLayerLegend__alert {\n    padding: 4px;\n    margin: 10px 0;\n}\n\n/*Popover*/\n.esbMapPopover table {\n    table-layout: fixed;\n    width: 260px;\n}\n\n.esbMapPopover td {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n/*Scale line*/\n.olEsbScaleLine.ol-scale-line {\n    padding: 3px;\n    border-radius: 0;\n    position: relative;\n    bottom: unset;\n    left: unset;\n}\n\n/*Attribution*/\n.olEsbAttribution.ol-attribution {\n    position: relative;\n    max-width: 100%;\n}\n\n/*Control layer*/\n.olEsbControls--absolute {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    max-width: 70%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
